import httpClient from "@/plugins/axios";

export const getWallpapers = async () => {
    const response = await httpClient.get(`/v1/wallpapers/`);
    return response;
}
